import FormImageGalleryField from "./fields/Form/ImageGalleryField.vue"
import DetailImageGalleryField from "./fields/Detail/ImageGalleryField.vue"
import IndexImageGalleryField from "./fields/Index/ImageGalleryField.vue"

const imageGalleryFieldSetup = (app) => {
    app.component('form-image-gallery-field', FormImageGalleryField)
    app.component('detail-image-gallery-field', DetailImageGalleryField)
    app.component('index-image-gallery-field', IndexImageGalleryField)
}

export { imageGalleryFieldSetup }
